/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 
 */

import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
// import de from '../locales/de/core.json';
import en from '../locales/en/core.json';

function loadLocales(url, options, callback) {
	switch (url) {
		case 'en': {
			import('../locales/en/core.json').then(locale => {
				callback(locale, { status: '200' });
				return true;
			}).catch(() => { console.log('Error loading ' + url + ' locale.'); });
			break;
		}
		case 'de': {
			import('../locales/de/core.json').then(locale => {
				callback(locale, { status: '200' });
				return true;
			}).catch(() => { console.log('Error loading ' + url + ' locale.'); });
			break;
		}
		default: {
			callback(en, { status: '200' });
			break;
		}
	}
}

const options = {
	fallbackLng: ['en', 'de'],
	ns: ['core'],
	defaultNS: 'core',
	attributes: ['t', 'i18n'],
	backend: {
		loadPath: '{{lng}}',
		parse: data => data, // comment to have working i18n switch
		ajax: loadLocales // comment to have working i18n switch
	},
	react: {
		wait: true
	},
	// debug: true,
	// getAsync: true,
	/* interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ',',
		format: (value, format) => {
			if (format === 'uppercase') return value.toUpperCase();
			return value;
		}
	} */
};

/* i18n.use(XHR).use(LanguageDetector).use(reactI18nextModule).init(options, (err, t) => {
  console.log('Test i18next: ' + t('core:name')); // -> same as i18next.t
  console.log('Test i18next: ' + i18n.t('core:name')); // -> same as i18next.t
  console.log(i18n.t('core:name')); // -> same as i18next.t
  if (err) {
    return console.log('something went wrong loading', err);
  }
}); */

i18n
	.use(XHR)
	.use(LanguageDetector)
	.use(reactI18nextModule)
	.init(options, (err) => {
		// console.log('init: ' + t('core:name')); // -> same as i18next.t
		// force loading en
		i18n.t('i18n', { lng: 'de' }); // -> "Internationalization"
		if (err) {
			return console.log('something went wrong loading', err);
		}
	});

// catch the event and make changes accordingly
i18n.on('languageChanged', (lng) => {
	// E.g. set the moment locale with the current language
	console.log('languageChanged: ', lng)
});

export default i18n;

